/**
 * Condense several lists into one list, deduplicating based on a key.
 * Lists are processed in order, so an item with a duplicating key will replace the existing entry.
 */
export const mergeById = <T>(
  getId: (t: T) => number,
  targetList: T[],
  mergeList: T[],
  prependNewItems: boolean = false,
): T[] => {
  const orderedIds: number[] = [];
  const newIds: number[] = [];
  const hash: { [key: number]: T } = {};

  for (const item of targetList) {
    if (item == null) {
      continue;
    }

    const id = getId(item);
    orderedIds.push(id);
    hash[id] = item;
  }

  for (const item of mergeList) {
    if (item == null) {
      continue;
    }

    const id = getId(item);
    if (!hash[id]) {
      newIds.push(id);
    }

    hash[id] = item;
  }

  // Objects don't maintain order of property insertion for numeric keys
  // - automatically lexically sorted - but this is an engine detail
  // To be fully correct, record order each item is encountered, and then read items from the hash in that order
  // This feels super inefficient but hey it's JS
  const mergedItems: T[] = [];

  const ids = prependNewItems ? newIds.concat(orderedIds) : orderedIds.concat(newIds);
  for (const id of ids) {
    const item = hash[id];
    if (item) {
      mergedItems.push(item);
      delete hash[id];
    }
  }

  return mergedItems;
};
